import { useInfiniteQuery } from '@tanstack/react-query';
import { partnerApi } from '../../../lib/api';
import { STANDARD_CACHE } from '../useAgentComponents';

export type ToolListFilter = 'active' | 'inactive' | 'all';

const STATUS_PARAM = {
  active: 'active',
  inactive: 'inactive',
  all: undefined,
} as const satisfies Record<ToolListFilter, 'active' | 'inactive' | undefined>;

/** The partner's tools matching the status filter, with where each is used, one page at a time. */
export function useToolList(filter: ToolListFilter) {
  return useInfiniteQuery({
    queryKey: ['ai-tools', filter],
    queryFn: ({ pageParam }) => partnerApi.getTools({ status: STATUS_PARAM[filter], cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage =>
      lastPage.pagination?.hasNextPage ? (lastPage.pagination.cursor ?? undefined) : undefined,
    select: toolPages => toolPages.pages.flatMap(page => page.tools),
    ...STANDARD_CACHE,
  });
}
